import {
  invalidateCache as publicInvalidateCache,
  purgeSiteCache as publicPurgeSiteCache,
} from './ssr-v1-invalidate-cache-request-cache.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const invalidateCache: MaybeContext<
  BuildRESTFunction<typeof publicInvalidateCache> & typeof publicInvalidateCache
> = /*#__PURE__*/ createRESTModule(publicInvalidateCache);
export const purgeSiteCache: MaybeContext<
  BuildRESTFunction<typeof publicPurgeSiteCache> & typeof publicPurgeSiteCache
> = /*#__PURE__*/ createRESTModule(publicPurgeSiteCache);

export {
  InvalidateCacheRequest,
  InvalidationMethods,
  InvalidationMethodsInvalidateByOneOf,
  InvalidateCacheResponse,
  PurgeSiteCacheRequest,
  PurgeSiteCacheResponse,
} from './ssr-v1-invalidate-cache-request-cache.universal.js';
